interface ResourceHeaderProps {
  title: string;
  subtitle: string;
  Icon: React.ReactNode;
  deletedAt?: string;
}

const ResourceHeader = ({
  title,
  subtitle,
  Icon,
  deletedAt,
}: ResourceHeaderProps): JSX.Element => {
  return (
    <div className="">
      <div className="flex items-center space-x-2 text-2xl font-semibold">
        <div className="flex items-center">{Icon}</div>
        <div className="flex flex-col">
          <h1 className="text-2xl">{title}</h1>
          <h2 className="text-lg text-gray-500">{subtitle}</h2>
        </div>
      </div>
      {deletedAt !== undefined && (
        <div className="flex items-center">
          <span className="text-red-500 font-semibold text-lg">
            This resource was deleted at {deletedAt}
          </span>
        </div>
      )}
    </div>
  );
};

export default ResourceHeader;
